import React, { ReactElement } from 'react'

import { vatFieldOptions } from './vatFieldOptions'
import ControlledSelectField from '../ControlledSelectField'
import { IControlledForm } from '../../utils/controlled-form'

export interface IVatFieldProps extends IControlledForm {
  placeholder: string
  label?: string | ReactElement
  disabled?: boolean
  inline?: boolean
}

const ControlledVatField = ({ ...props }: IVatFieldProps) => {
  return <ControlledSelectField {...props} options={vatFieldOptions} />
}

export default ControlledVatField
